import { Shortcut } from 'shortcuts';

import type { ShortcutAction } from '../components/ShortcutManager/ShortcutManager.types';
import { actionStore } from '../components/ShortcutManager/Store';

import useEvent from './useEvent';
import useSimpleStore from './useSimpleStore';

/**
 * Hook to attach a callback to the keyboard shortcut action.
 * @param actionId the identifier of the action to attach the callback to
 * @param callback function that should be invoked when given action gets triggered
 * @returns current shortcut bound to the given action in form of accelerator
 */
const useShortcut = (
  actionId: ShortcutAction['id'],
  callback: (e: ShortcutEvent) => void
): { binding?: string } => {
  const [definition] = useSimpleStore(actionStore, store => store[actionId]);

  useEvent(
    'shortcut',
    e => {
      if (e.detail.actionId === actionId) callback(e);
    },
    {
      dependencies: [actionId, callback]
    }
  );

  return {
    binding: definition ? Shortcut.shortcut2accelerator(definition.keyBinding) : undefined
  };
};

export default useShortcut;
